
import "/app/src/components/EnterpriseDetailPanel/index.module.less?modules";
export default {"body": `body-H7-bcKvs`,"state": `state-WZgraC52`,"archiveBlock": `archiveBlock-yuxL0vqp`}
